"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttackBasicStyles = void 0;
exports.createAttackBasicLayer = createAttackBasicLayer;
const react_jss_1 = require("react-jss");
const ATTACK_DURATION_MS = 200;
const ATTACK_MOVEMENT_MULTIPLIER_PX = 3;
exports.useAttackBasicStyles = (0, react_jss_1.createUseStyles)({
    "@keyframes piece-attack-basic-anim": {
        "0%": {
            transform: "translate(0, 0)",
        },
        "50%": {
            transform: "translate(" +
                `calc(${ATTACK_MOVEMENT_MULTIPLIER_PX}px * var(--attackPower) * var(--attackXDirection)), ` +
                `calc(${ATTACK_MOVEMENT_MULTIPLIER_PX}px * var(--attackPower) * var(--attackYDirection))` +
                ")",
        },
        "100%": {
            transform: "translate(0, 0)",
        },
    },
    "attackBasic": {
        animationName: "$piece-attack-basic-anim",
        animationDuration: `${ATTACK_DURATION_MS}ms`,
    },
});
function createAttackBasicLayer(event, className) {
    return {
        name: "attackBasic",
        className,
        cssVariables: {
            attackPower: event.damage,
            attackXDirection: event.direction.x,
            attackYDirection: event.direction.y,
        },
    };
}
